
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"11","viewBox":"0 0 12 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 5.017a1.25 1.25 0 00-1.25-1.25H7.595a.125.125 0 01-.119-.164 4.34 4.34 0 00.26-2.204C7.442.35 6.819.05 6.332.118A1 1 0 005.5 1.142c0 1.373-1.064 2.873-2.017 3.53a.25.25 0 00-.108.207v5.058c0 .12.085.222.203.245.178.034.34.067.493.1a8.68 8.68 0 002.054.236h3.25c.979 0 1.125-.55 1.125-.876 0-.172-.04-.342-.116-.497.55-.279.772-.947.5-1.5a1.125 1.125 0 00.48-1.539A1.25 1.25 0 0012 5.017zm-9.375-.125a.5.5 0 00-.5-.5H.5a.5.5 0 00-.5.5v5.5a.5.5 0 00.5.5h1.625a.5.5 0 00.5-.5v-5.5zm-.75 4.625a.375.375 0 11-.75 0 .375.375 0 01.75 0z","fill":"#C3AFA3"}})])
          )
        }
      }
    